<template>
  <div
    class="i-coaching-notice"
    @click="goToSelectCoach"
  >
    <div class="wrap">
      <div class="text white">Want personalized guidance from a career coach?</div>
      <div class="text highlight">Upgrade to 1:1 Coaching</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router"
import { useUserStore } from "@/stores/user"

import { GlobalVariables } from "@/helpers/globalVariables"

// ROUTER AND STORES
const router = useRouter()
const userStore = useUserStore()

// METHODS
const goToSelectCoach = () => {
  router.push({
    name: userStore.isExecutiveCoachingPotential
      ? GlobalVariables.urls.coaching.children.chooseCoach.routeName
      : GlobalVariables.urls.coaching.children.selectCoach.routeName
  })
}
</script>

<style lang="scss" scoped>
.i-coaching-notice {
  cursor: pointer;
  background-color: $black-pearl950;
  width: 100%;
  height: 48px;
  text-align: center;

  @include flex($direction: row, $justify: center, $align: center);

  .wrap {
    @include flex(row, center, center, wrap, $gap: 2px 8px);

    @media screen and (min-width: $breakpoint-sm) {
      gap: 2px 12px;
    }

    @media screen and (min-width: $breakpoint-md) {
      gap: 16px;
    }

    .text {
      @include text-xs;

      @media screen and (min-width: $breakpoint-xs) {
        @include text-sm;
      }

      @include flex($direction: row, $justify: center, $align: center, $gap: 4px);

      font-weight: 500;

      &.white {
        color: $white;
      }

      &.highlight {
        background: linear-gradient(90deg, $azure-radiance400 0%, $amethyst300 100%);
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
}

@media print {
  .i-coaching-notice {
    display: none;
  }
}
</style>
